/**
 * Replaces `${key}` tokens in `template` for each entry in `variables`. Missing / null values become `''`.
 */
export function substitutePlainTextVariables(
  template: string,
  variables: Record<string, string | number | undefined | null>,
): string {
  let result = template;
  for (const [name, raw] of Object.entries(variables)) {
    const token = '$' + '{' + name + '}';
    const value = raw === undefined || raw === null ? '' : String(raw);
    result = result.replaceAll(token, value);
  }
  return result;
}
